import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledUpdateBanner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    background-color: ${({ theme }) => theme.infoBackground};
`;

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
    font-size: 20px;
    color: ${({ theme }) => theme.colors.warning};
`;
